import { useQuery } from '@tanstack/react-query'
import moment from 'moment'

import { getDailyWelcomeMessage } from '../api'
import { welcomeMessageKey } from '../queryKeys'

export const useGetDailyWelcomeMessage = (
  accountId: string,
  userFirstName: string
) => {
  const usersCurrentDate = moment().toISOString()
  const getWelcomeMessage = useQuery([welcomeMessageKey, accountId], () =>
    getDailyWelcomeMessage({
      userFirstName,
      usersCurrentDate,
    })
  )

  return getWelcomeMessage
}
